import { render, staticRenderFns } from "./stories_table.vue?vue&type=template&id=bf239506&scoped=true&lang=pug"
import script from "./stories_table.vue?vue&type=script&lang=js"
export * from "./stories_table.vue?vue&type=script&lang=js"
import style0 from "./stories_table.vue?vue&type=style&index=0&id=bf239506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf239506",
  null
  
)

export default component.exports